import React from 'react';
import {
  FormattedMessage,
  FormattedNumber,
  FormattedRelativeTime,
  useIntl,
} from 'react-intl';
import { Badge } from 'reactstrap';
import {
  capitalize,
  getOrderStatusPillColor,
} from '../../../../utility/util/util.service';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { connect } from 'react-redux';
import {
  setIsListOrdersModalOpen,
  setIsOrderInfoModalOpen,
  setOrderInfoModalData,
} from '../../../../redux/modal/modal.actions';
import PropTypes from 'prop-types';
import Empty from '../../../../views/errors/empty.component';
import AvatarGroup from '../../../@vuexy/avatar/AvatarGroup';
import {
  ORDER_STATUS_DELIVERING,
  ORDER_STATUS_PAID,
  ORDER_STATUS_PREPARED,
  ORDER_STATUS_PREPARING,
  ORDER_STATUS_PROCESSING,
} from '../../../../utility/constants';
import { isPendingOrderStatus } from '../order-info/order-info.service';

const ListOrdersModal = ({
  isOpen,
  data,
  orders,

  setIsListOrdersModalOpen,
  setIsOrderInfoModalOpen,
  setOrderInfoModalData,
}) => {
  const filteredOrders = orders?.filter(
    (order) =>
      data?.onlyPending
        ? [
            ORDER_STATUS_PROCESSING,
            ORDER_STATUS_PAID,
            ORDER_STATUS_PREPARING,
            ORDER_STATUS_PREPARED,
            ORDER_STATUS_DELIVERING,
          ].includes(order.status)
        : true, // include all (don't filter)
  );
  const intl = useIntl();
  const closeModal = () => setIsListOrdersModalOpen(false);

  return (
    <>
      <ModalSheet
        isOpen={isOpen}
        closeModal={closeModal}
        title={intl.formatMessage({ id: 'listUserOrdersTitle' })}
      >
        {filteredOrders?.length > 0 ? (
          <div className="pb-1 px-1">
            {filteredOrders?.map((order, index) => {
              // sort by image available
              order.items.sort(
                (a, b) =>
                  Number(!!b.itemData?.image) - Number(!!a.itemData?.image),
              );
              const previewData = order.items
                .slice(0, 3)
                .map(({ itemData }) => ({
                  className: 'squared',
                  img: itemData?.image,
                  size: 'lg',
                }));

              // add the remainingCount as last avatarData
              if (order.items.length > previewData.length) {
                const remainingItemsCount =
                  order.items.length - previewData.length;
                previewData.push({
                  className: 'squared',
                  content: remainingItemsCount.toString(),
                  size: 'lg',
                });
              }

              const orderAgoSeconds =
                (new Date(order.createdAt) - new Date()) / 1000;
              const updateIntervalSeconds =
                orderAgoSeconds < 60 ? 1 : orderAgoSeconds < 60 * 60 ? 60 : 0;

              return (
                <div
                  key={index}
                  data-testid="orderListItem"
                  className="d-flex align-items-center justify-content-between mb-2"
                  onClick={() => {
                    setOrderInfoModalData({ order: order, isInitial: false });
                    setIsOrderInfoModalOpen(true);
                  }}
                >
                  <div style={{ width: '105px' }}>
                    <AvatarGroup data={previewData} />
                  </div>
                  <div
                    className="d-flex flex-column flex-grow-1"
                    style={{ minWidth: 0 }}
                  >
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <span className="d-block font-small-3 text-nowrap">
                        <Badge color={order && getOrderStatusPillColor(order)}>
                          <FormattedMessage
                            id={
                              'orderStatus' +
                              capitalize(order?.status) +
                              (isPendingOrderStatus(order?.status)
                                ? `Ago@${order?.type}`
                                : '')
                            }
                            values={{ ago: '' }}
                          />
                        </Badge>
                      </span>
                      <span className="d-block font-small-3 text-nowrap">
                        {order?.checkoutMethod === 'pay_and_go' ? (
                          <FormattedMessage id="orderStatusPaid" />
                        ) : (
                          <FormattedMessage id="ordered" />
                        )}
                        <FormattedRelativeTime
                          value={orderAgoSeconds}
                          format="long"
                          updateIntervalInSeconds={updateIntervalSeconds}
                        />
                      </span>
                      <span className="d-block font-small-2 text-nowrap">
                        <FormattedMessage
                          id="listUserOrdersAtStore"
                          values={{
                            storeName: order.merchantProfile.store.name,
                          }}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="d-flex flex-column justify-content-center align-items-end">
                    <FormattedNumber
                      value={order.total}
                      format="priceCurrency"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <Empty
            className="mt-2 mb-3"
            titleId="emptyOrderListTitle"
            subTitleId="emptyOrderListSubTitle"
          />
        )}
      </ModalSheet>
    </>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isListOrdersModalOpen,
  data: state.modals.listOrdersModalData,
  orders: state.me.orders,
});

export default connect(mapStateToProps, {
  setIsListOrdersModalOpen,
  setIsOrderInfoModalOpen,
  setOrderInfoModalData,
})(ListOrdersModal);
